import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { HttpClient } from "@angular/common/http";
import { en } from '../environments/environment.tok'
import { en as enk } from '../environments/environments.k'
import { AuthenticationService } from './authentication.service';
@Injectable({
  providedIn: 'root'
})
export class TokenService {

  token = en.token;
  session = en.session
  async getIPAddress() {
    await this.http.get("https://api.ipify.org/?format=json").subscribe((res: any) => {
      this.session = res.ip;
      // console.log(res);
    });
  }
  constructor(private http: HttpClient) {
    this.token = this.encryptUsingAES256(en.token);
    this.getIPAddress();
  }
  ///********************************OTP **********************************************************************************
  encryptUsingAES256(request: any) {
    let _key = CryptoJS.enc.Utf8.parse(enk.jump);
    let _iv = CryptoJS.enc.Utf8.parse(enk.jump);
    let encrypted = CryptoJS.AES.encrypt(
      JSON.stringify(request), _key, {
      keySize: 16,
      iv: _iv,
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.toString();
  }
  ///********************************OTP **********************************************************************************
}
